import Reassurance from '$components/composite/Reassurance';
import Container from './styled';

export default function UspBanner() {
  return (
    <Container>
      <Reassurance
        theme="light"
        // eslint-disable-next-line max-len
        subTitle="Fixter was founded to make car repair as easy as booking a taxi. A digital, end-to-end service that’s transparent and stress-free."
      />
    </Container>
  );
}
